import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
  CssBaseline,
  StyledEngineProvider,
} from "@mui/material";
import typography from "./typography";
import palette from "./palette";
import shadows, { customShadows } from "./shadow";

export default function ThemeProvider({ children }) {
  const theme = createTheme({
    typography,
    palette,
    shadows,
    shape: { borderRadius: 8 },
    customShadows,
  });

  theme.components = {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[3],
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          paddingTop: 4,
          paddingBottom: 0,
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          paddingBottom: "8px !important",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
        sizeLarge: {
          height: 48,
        },
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          paddingTop: theme.spacing(3),
          paddingBottom: theme.spacing(1),
          lineHeight: 0,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 30,
          borderRadius: 5,
        },
        colorPrimary: {
          backgroundColor: theme.palette.grey[200],
        },
        bar: {
          borderRadius: 5,
          backgroundColor: "#1a90ff",
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: "#1a90ff",
        },
      },
    },
    MuiDivider: {
      variants: [
        {
          props: { variant: "dashed" },
          style: {
            borderStyle: "dashed",
          },
        },
      ],
    },
    MuiTextField: {
      defaultProps: {
        InputLabelProps: {
          shrink: true,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          [theme.breakpoints.down("md")]: {
            minWidth: 100,
          },
          [theme.breakpoints.down("sm")]: {
            minWidth: 67,
          },
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          position: "relative",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderTop: "1px solid rgba(224, 224, 224, 1)",
          borderBottom: 0,
        },
        head: {
          borderTop: 0,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          borderBottom: "0 !important",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  };

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
}
